import {axiosGetHandler, axiosPostHandler} from './config'
import {extractAPIValues} from '_lib/utils/utils'
const {BASE_API, BASE_XHH} = extractAPIValues()

// 获取社区列表
export function getTopicList(args) {
  let url = BASE_XHH + '/bbs/app/topic/categories'
  return axiosGetHandler(url, args)
}

// 搜索社区
export function searchTopic(args, formdata) {
  let url = BASE_XHH + '/bbs/app/topic/search'
  return axiosPostHandler(url, args, formdata)
}

// 发布帖子
export function createPost(args, formdata) {
  let url = BASE_XHH + '/bbs/app/api/link/post'
  return axiosPostHandler(url, args, formdata)
}

// 获取帖子列表
export function getPostList(args) {
  let url = BASE_XHH + '/bbs/app/topic/feeds'
  return axiosGetHandler(url, args)
}

// 获取帖子详情
export function getPostDetail(args) {
  let url = BASE_XHH + '/bbs/app/link/tree'
  return axiosGetHandler(url, args)
}

export function searchPost(args) {
  let url = BASE_XHH + '/chatroom/v2/channel/search/link'
  return axiosGetHandler(url, args)
}

// 评论帖子
export function commentPost(args, formdata) {
  let url = BASE_XHH + '/bbs/app/comment/create'
  return axiosPostHandler(url, args, formdata)
}

// 点赞
export function awardPost(args, formdata) {
  let url = BASE_XHH + '/bbs/app/profile/award/link'
  return axiosPostHandler(url, args, formdata)
}

// 收藏帖子
export function favourPost(args, formdata) {
  let url = BASE_XHH + '/bbs/app/link/favour'
  return axiosPostHandler(url, args, formdata)
}

// 收藏夹列表
export function favFolderList(args) {
  let url = BASE_XHH + '/bbs/app/profile/fav/folders'
  return axiosGetHandler(url, args)
}

// 收藏列表
export function favLinksList(args) {
  let url = BASE_XHH + '/bbs/app/profile/fav/folder/links'
  return axiosGetHandler(url, args)
}

// 赞&评论列表
export function awardCommentList(args) {
  let url = BASE_XHH + '/bbs/app/user/message'
  return axiosGetHandler(url, args)
}

// 获取未读消息数量
export function getPostMsgUnread(args) {
  let url = BASE_XHH + '/bbs/app/user/msg_unread_num'
  return axiosGetHandler(url, args)
}

// 历史浏览
export function historyList(args) {
  let url = BASE_XHH + '/bbs/app/profile/history/visit'
  return axiosGetHandler(url, args)
}

// 我的发布
export function myPostList(args) {
  let url = BASE_XHH + '/bbs/app/profile/events'
  return axiosGetHandler(url, args)
}

// 清除未读消息
export function clearPostUnread(args) {
  let url = BASE_XHH + '/bbs/app/user/chat_reset_unread'
  return axiosGetHandler(url, args)
}